var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHubspotLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.836 17.17v-4.763a3.667 3.667 0 002.115-3.306v-.11a3.668 3.668 0 00-3.668-3.667h-.11a3.668 3.668 0 00-3.667 3.668V9.1a3.668 3.668 0 002.115 3.306v4.763a10.387 10.387 0 00-4.94 2.175L12.619 9.17a4.09 4.09 0 00.147-1.03 4.132 4.132 0 10-4.138 4.125 4.088 4.088 0 002.035-.554l12.864 10.01a10.42 10.42 0 00.16 11.737l-3.913 3.914a3.363 3.363 0 00-.978-.16 3.395 3.395 0 103.397 3.397 3.348 3.348 0 00-.16-.978l3.871-3.872a10.437 10.437 0 107.933-18.589zm-1.604 15.666a5.353 5.353 0 01-3.881-9.19 5.355 5.355 0 013.88-1.515 5.354 5.354 0 01.006 10.703",
    fill: "#FF7A59"
  })));
}

export default __webpack_public_path__ + "./fonts/hubspot-logo.964ba145cae791104c21abe71be87f35.svg";
export { SvgHubspotLogo as ReactComponent };